<template>
    <path
        fill="currentColor"
        d="M3.15 13.1L2.9 12.85L6.35 9.4H3.9v-.5h3.7v3.7h-.5V10.05zM8.6 8.6V4.9h.5v2.65L12.75 3.9l.35.35L9.45 7.9h2.65v.5z"
    />
</template>
